import React from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import "./strategic-offerings-section.m.css";
import Chevron from "../../../../assets/icons/chevron";

const StrategicOfferingsSection = () => {
  const cdnHost = useSelector((state) => get(state, ["qt", "config", "cdn-image"]));
  const commisionedbriefingsImageKey = useSelector((state) => get(state, ["qt", "config", "publisher-attributes","homePageData","commisionedBriefingsImageKey"], {}));
  const partneredengagementsImageKey = useSelector((state) => get(state, ["qt", "config", "publisher-attributes","homePageData","partneredEngagementsImageKey"], {}));
  const commissionedBriefingsImg = `https://${cdnHost}/${commisionedbriefingsImageKey}`;
  const partneredEngagementsImg = `https://${cdnHost}/${partneredengagementsImageKey}`;
  const offerings = [
    {
      title: "Commissioned briefings",
      description: "Bespoke analysis and insights for strategic decision-making",
      image: commissionedBriefingsImg,
      href: '/commissioned-briefings'
    },
    {
      title: "Partnered engagements",
      description: "Co-created research and events, positioning you for thought leadership",
      image: partneredEngagementsImg,
      href: '/partnered-engagement'
    }
  ];

  return (
    <div styleName="strategic-offerings-section">
      <div styleName="container">
        <div styleName="header">
          <div styleName="shoulder-tag">
            Strategic offerings
          </div>
          <h2 styleName="section-heading">
            Understanding today. Anticipating tomorrow
          </h2>
        </div>

        <div styleName="content">
          {offerings.map((offering, index) => (
            <div key={index} styleName="offering-item">
              <div styleName="offering-header">
                <a href={offering.href} styleName="offering-title">
                  {offering.title}
                  <div styleName="arrow-icon"><Chevron color="#242424" /></div>
                </a>
              </div>
              <p styleName="offering-description">
                {offering.description}
              </p>
              <div styleName="offering-image">
                <img
                  src={offering.image}
                  alt={offering.title}
                  styleName="banner-image"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export { StrategicOfferingsSection };